import TopMenu from "../../TopMenu";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { get } from "../../../../utils/api";
import { companyId } from "../../../../utils/companyId";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";

const Main = () => {
  const { user } = useUser();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedOption, setSelectedOption] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isShortContent, setIsShortContent] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10); // Number of items per page
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [filterObj, setFilterObj] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [columnWidth, setcolumnWidth] = useState(
    user?.companyAdmin ? "12% 15% 15% 15% 15% 16% 8%" : "12% 20% 20% 18% 18% 8%"
  );
  const [url, setUrl] = useState(
    "/consumptionByEquipment/getConsumptionByEquipmentDoc"
  );
  const [Doc, SetDoc] = useState([]);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  useEffect(() => {
    fetchData();
  }, [
    page,
    rowsPerPage,
    searchQuery,
    url,
    filterObj,
    fromDate,
    toDate,
    selectedFacility,
  ]);

  const fetchData = async (filters = filterObj) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
        search: searchQuery,
        facilityList: selectedFacility.join(","),
        // minCurrentMeterReading,
        // maxCurrentMeterReading,
        // minUnitConsumption,
        // maxUnitConsumption,
      }).toString();
      const response = await get(
        `/scope2/${url}?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data); // Update the user list
      SetDoc(response.data.data);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const toggleData = [
    {
      title: "Consumption by Equipment",
      url: "/consumptionByEquipment/getConsumptionByEquipmentDoc",
    },
    {
      title: "Consumption by Facility",
      url: "/consumptionByFacility/consumptionByFaciltyDoc",
    },
    {
      title: "Bulk Upload",
      url: "/bulkUpload/getBulkUploadDoc",
    },
  ];

  const heading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Equipment",
      key: "equipment",
      field: "equipment",
    },
    {
      title: "Brand",
      key: "brand",
    },
    {
      title: "Model",
      key: "model",
    },
  ].filter(Boolean);

  const heading2 = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Vendor",
      key: "vendor",
      field: "VendorLegalFullName",
    },
    {
      title: "Previous Meter Reading",
      key: "previousMeterReading",
    },
    {
      title: "Current Meter Reading",
      key: "currentMeterReading",
    },

    {
      title: "Energy Consumption",
      key: "unitOfElectricityConsumption",
    },
  ].filter(Boolean);

  const heading3 = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "uploadPeriod",
      title: "Upload Period",
    },
    {
      title: "File Name",
      key: "fileName",
    },
    {
      title: "Upload Status",
      key: "uploadStatus",
    },
    {
      title: "Records Processed",
      key: "recordsProcessed",
    },
    {
      title: "Uploaded By",
      key: "uploadedBy",
    },
  ].filter(Boolean);

  const [toggleHeding, SetHeading] = useState(heading);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope2${url}`);
      const data = response.data.data;

      const uniqueEquipment = [
        ...new Set(
          data.map((el) => el.equipment?.equipment) // Filter out undefined values
        ),
      ];
      const uniqueBrand = [
        ...new Set(
          data.map((el) => el.brand) // Filter out undefined values
        ),
      ];
      const uniqueModel = [
        ...new Set(
          data.map((el) => el.model) // Filter out undefined values
        ),
      ];
      const uniqueFileName = [
        ...new Set(
          data.map((el) => el.fileName) // Filter out undefined values
        ),
      ];
      const uniqueUploadStatus = [
        ...new Set(
          data.map((el) => el.uploadStatus) // Filter out undefined values
        ),
      ];
      console.log(uniqueEquipment, "searching for unique values");
      setFilterOptions({
        equipment: uniqueEquipment,
        brand: uniqueBrand,
        model: uniqueModel,
        fileName: uniqueFileName,
        uploadStatus: uniqueUploadStatus,
      });
      return {
        equipment: uniqueEquipment,
        brand: uniqueBrand,
        model: uniqueModel,
        fileName: uniqueFileName,
        uploadStatus: uniqueUploadStatus,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };
  let filtersToApply = {};

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Equipment",
      type: "option",
      key: "equipment",
      value: filterOptions.equipment,
    },
    {
      title: "Brand",
      type: "option",
      key: "brand",
      value: filterOptions.brand,
    },
    {
      title: "Model",
      type: "option",
      key: "model",
      value: filterOptions.model,
    },
    // {
    //   title: "Freight Load (Tonnes)",
    //   type: "limit",
    //   key: "load",
    //   value: ["one", "two"],
    // },
  ];
  const filterData2 = [
    { title: "Date", type: "date", key: "createdAt", value: [] },

    {
      title: "Previous Reading",
      type: "limit",
      key: "PreviousMeterReading",
      value: ["one", "two"],
    },
    {
      title: "Current Reading",
      type: "limit",
      key: "CurrentMeterReading",
      value: ["one", "two"],
    },
    {
      title: "Energy Consumption",
      type: "limit",
      key: "UnitConsumption",
      value: ["one", "two"],
    },
  ];

  const filterData3 = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "File Name",
      type: "option",
      key: "fileName",
      value: filterOptions.fileName,
    },
    {
      title: "Upload Status",
      type: "option",
      key: "uploadStatus",
      value: filterOptions.uploadStatus,
    },
    {
      title: "Records Processed",
      type: "limit",
      key: "recordsProcessed",
      value: ["one", "two"],
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    // selectedOption === "Consumption by Equipment" ?

    // setFilterObj((prev)=>{
    //   ...prev,
    //   newFilterObj
    // })
    // : setFilterObj((prev) => ({
    //   ...prev,
    //   // ...newFilterObj,
    //   ...(newFilterObj?.PreviousMeterReading && {
    //     minPreviousMeterReading: newFilterObj.PreviousMeterReading.min || undefined,
    //     maxPreviousMeterReading: newFilterObj.PreviousMeterReading.max || undefined,
    //   }),
    //   ...(newFilterObj?.CurrentMeterReading && {
    //     minCurrentMeterReading: newFilterObj.CurrentMeterReading.min || undefined,
    //     maxCurrentMeterReading: newFilterObj.CurrentMeterReading.max || undefined,
    //   }),
    //   ...(newFilterObj?.UnitConsumption && {
    //   minUnitConsumption: newFilterObj?.UnitConsumption?.min || undefined,
    //   maxUnitConsumption: newFilterObj?.UnitConsumption?.max || undefined,
    // }),
    // }))
    if (selectedOption === "Consumption by Equipment") {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj, // Directly merge newFilterObj when selectedOption matches
      }));
    } else if (selectedOption === "Bulk Upload") {
      setFilterObj((prev) => ({
        ...prev,
        ...(newFilterObj?.recordsProcessed && {
          minRecordsProcessed: newFilterObj.recordsProcessed.min || undefined,
          maxRecordsProcessed: newFilterObj.recordsProcessed.max || undefined,
        }),
        ...newFilterObj,
      }));
    } else {
      setFilterObj((prev) => ({
        ...prev,
        ...(newFilterObj?.PreviousMeterReading && {
          minPreviousMeterReading:
            newFilterObj.PreviousMeterReading.min || undefined,
          maxPreviousMeterReading:
            newFilterObj.PreviousMeterReading.max || undefined,
        }),
        ...(newFilterObj?.CurrentMeterReading && {
          minCurrentMeterReading:
            newFilterObj.CurrentMeterReading.min || undefined,
          maxCurrentMeterReading:
            newFilterObj.CurrentMeterReading.max || undefined,
        }),
        ...(newFilterObj?.UnitConsumption && {
          minUnitConsumption: newFilterObj.UnitConsumption.min || undefined,
          maxUnitConsumption: newFilterObj.UnitConsumption.max || undefined,
        }),
      }));
    }

    console.log("Applied Filters:", newFilterObj);
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
    
    if (option === "Consumption by Equipment") {
      SetHeading(heading);
      setcolumnWidth(
        user?.companyAdmin
          ? "12% 15% 15% 15% 15% 16% 8%"
          : "12% 20% 20% 18% 18% 8%"
      );
    } else if (option === "Consumption by Facility") {
      SetHeading(heading2);
      setcolumnWidth(
        user?.companyAdmin
          ? "11% 14% 13% 12% 13% 11% 14% 8%"
          : "12% 15% 13% 16% 16% 16% 8%"
      );
    } else if (option === "Bulk Upload") {
      SetHeading(heading3);
      setcolumnWidth(
        user?.companyAdmin
          ? "12% 15% 15% 15% 15% 16% 8%"
          : "12% 20% 20% 18% 18% 8%"
      );
    }
  };

  useEffect(() => {
    setSelectedOption(toggleData?.[0].title);
    setUrl(toggleData?.[0].url);
  }, []);

  // Get appropriate filters based on selected option
  const getFilters = () => {
    switch (selectedOption) {
      case "Consumption by Equipment":
        return filterData;
      case "Consumption by Facility":
        return filterData2;
      case "Bulk Upload":
        return filterData3;
      default:
        return filterData;
    }
  };

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
        <>
          <TopMenu
            {...{
              setDrawerFilterOpen: setIsFilterModalOpen,
              selectedMonth,
              setSelectedMonth,
              selectedYear,
              setSearchQuery,
              setSelectedYear,
              selectedOption,
              handleToggle,
              filterApplied: isFilterModalOpen,
              toggleData,
              fromDate,
              setFromDate,
              toDate,
              setToDate,
              selectedFacility,
              setSelectedFacility,
            }}
            heading={"Electricity"}
          />
          <Box
            sx={{
              backgroundColor: "#ededed",
            }}
          >
            <TableDocument
              data={Doc}
              totalPages={1}
              headers={toggleHeding}
              columnWidth={columnWidth}
              // columnWidth={toggleData?.[0]?"10% 20% 15% 15% 15% ":"11% 18% 20% 20% 18% 8%"}
            />
          </Box>
          <FilterModal
            isOpen={isFilterModalOpen}
            onClose={() => setIsFilterModalOpen(false)}
            filters={getFilters()}
            onFilterChange={handleFilterChange}
            title="Filter"
          />
        </>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default Main;
